const loginTexts = {
  title: 'Entrar na Loggi',
  subtitle: 'Que bom ter você por aqui. Digite seu telefone para entrar.',
  phone: 'Telefone',
  login: 'Entrar'
};

export default loginTexts;
